import React from "react";
import Video from "./video";
import WaitingRoomSidebar from "../../waiting-room-sidebar";
import CallStatusProvider from "../../call-details/CallStatusProvider";
import { VIDEO_VISIT_TYPE } from "../../waiting-room-sidebar/constants";
import VideoCapabilities from '../../video-capabilities';

const VideoContainer = ({ consultation, ...props}) => {
  const { consultationId } = consultation;

  return (
    <CallStatusProvider consultationId={consultationId}>
      <VideoCapabilities
        consultationId={consultationId}
      />
      <div className="video-conference-container">
        <Video
          {...props}
          consultation={consultation}
        />
        <WaitingRoomSidebar
          consultation={consultation}
          visitType={VIDEO_VISIT_TYPE}
          currentUser={{roleCd: props.roleCd}}
        />
      </div>
    </CallStatusProvider>
  );
};

export default VideoContainer;
